// temp solution, remove once BE sent correct offer data in response (GC, SC)
export const OFFER_TEMP = 'OFFER_TEMP'
